/**
 * デバイスコードのログインの画面（pages/CliDevice.tsx）が本体を呼ぶ唯一の場所（2026-10-07 console/device-login）。
 * 型の正: docs/teams/console/tasks/device-login.md「約束」（Core device login が作る。食い違いはここだけ直す）。
 * 認証は kds_（ログイン中のセッション・api() が付ける）。approve / deny はメール確認済みが要る（今の cli-grants と同じ = 403 email_unverified）。
 * pending 以外への approve / deny は 409（期限切れ・使用済み・ほかのタブで答えた）。GET / approve には当て推量に備えた回数の制限がある（429）
 */
import { api } from './api';

const base = (userCode: string) => `/v1/developers/cli-device/${encodeURIComponent(userCode)}`;

/** 画面は useResource で読む（読み込み中・エラーの扱いを他の画面とそろえる）。応答は CliDeviceResponse（cliDevice.ts） */
export const cliDevicePath = (userCode: string) => base(userCode);

export function approveCliDevice(userCode: string) {
  return api<{ ok: true }>(`${base(userCode)}/approve`, { method: 'POST', body: {} });
}

export function denyCliDevice(userCode: string) {
  return api<{ ok: true }>(`${base(userCode)}/deny`, { method: 'POST', body: {} });
}
